import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { fireDB } from '../../firebase/FirebaseConfig';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { Col, Container, Row } from 'react-bootstrap';
import PopularCard from '../Cards/PopularCard';

const ExplorebyState = () => {
    const [tours, setTours] = useState([]);
    const navigate = useNavigate();

    const fetchTours = async () => {
        try {
            const snapshot = await getDocs(collection(fireDB, "tours"));
            const fetchedTours = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setTours(fetchedTours);
        } catch (error) {
            console.error("Error fetching tours:", error);
        }
    };
    const [selectedState, setSelectedState] = useState("Gujarat");
    const [toursByState, setToursByState] = useState([]);

    const fetchToursByState = async (stateName) => {
        try {
            const q = query(
                collection(fireDB, "tours"),
                where("state", "==", stateName),
                limit(4)
            );
            const snapshot = await getDocs(q);
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setToursByState(data);
        } catch (err) {
            console.error("Error fetching tours:", err);
        }

    };
    useEffect(() => {
        fetchToursByState(selectedState);
    }, [selectedState]);
    const states = [
        "Gujarat", "Rajasthan", "Delhi", "Kerala", "Uttar Pradesh", "Uttarakhand", "Himachal Pradesh", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Haryana", "Jammu Kashmir",
        "Jharkhand", "Karnataka", "Lakshadweep", "Madhya Pradesh",
        "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha",
        "Puducherry", "Punjab", "Sikkim", "Tamil Nadu", "Telangana",
        "Tripura", "West Bengal"
    ];

    useEffect(() => {
        fetchTours();
    }, []);


    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === "left" ? -200 : 200,
                behavior: "smooth",
            });
        }
    };
    return (
        <div>
            <section className="py-5 bg-light">
                <Container>
                    <Row>
                        <Col md="12" className="text-center mb-4">
                            <h2 className="fw-bold" style={{
                                fontSize: "1.5rem",
                                letterSpacing: "1px",
                                textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                            }}>🗺️ Explore by State</h2>
                            <p className="text-muted" style={{
                                fontSize: "1.1rem",
                                letterSpacing: "1px",
                                textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                            }}>Click a state to explore tours</p>
                        </Col>
                    </Row>



                    <div className="mb-4">
                        {/* Desktop: Grid */}
                        <div className="d-none d-md-flex flex-wrap gap-3 justify-content-center">
                            {states.map((state, idx) => (
                                <div
                                    className="scroll-item px-3 py-2 rounded-pill shadow-sm text-primary-emphasis"
                                    key={idx}
                                    style={{
                                        cursor: "pointer",
                                        minWidth: "120px",
                                        textAlign: "center",
                                        textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                                    }}
                                    onClick={() => setSelectedState(state)}
                                >
                                    {state}
                                </div>
                            ))}
                        </div>

                        {/* Mobile: Horizontal Scroll with Arrows */}
                        <div className="d-md-none position-relative">
                            <button
                                className="position-absolute start-0 top-50 translate-middle-y border-0 bg-transparent"
                                onClick={() => scroll("left")}
                                style={{
                                    fontSize: "20px",
                                    color: "#a3a19c",
                                    cursor: "pointer",
                                    zIndex: 1,
                                    lineHeight: 1,
                                }}
                            >
                                ◀
                            </button>

                            {/* Scrollable States */}
                            <div
                                ref={scrollRef}
                                className="d-flex gap-3 overflow-auto py-2 px-4"
                                style={{
                                    whiteSpace: "nowrap",
                                    scrollBehavior: "smooth",
                                    scrollSnapType: "x mandatory",
                                }}
                            >
                                {states.map((state, idx) => (
                                    <div
                                        className=" scroll-item px-3 py-2 rounded-pill shadow-sm text-primary-emphasis flex-shrink-0"
                                        key={idx}
                                        style={{
                                            cursor: "pointer",
                                            minWidth: "100px",
                                            textAlign: "center",
                                            scrollSnapAlign: "center",
                                            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                                        }}
                                        onClick={() => setSelectedState(state)}
                                    >
                                        {state}
                                    </div>
                                ))}
                            </div>

                            <button
                                className="position-absolute end-0 top-50 translate-middle-y border-0 bg-transparent"
                                onClick={() => scroll("right")}
                                style={{
                                    fontSize: "20px",
                                    color: "#a3a19c",
                                    cursor: "pointer",
                                    zIndex: 1,
                                    lineHeight: 1,
                                }}
                            >
                                ▶
                            </button>
                        </div>
                    </div>
                    {/* Show selected state's tours */}
                    <div className="mt-5">
                        <h2
                            className="fw-bold text-primary-emphasis text-center mb-4"
                            style={{
                                fontSize: "1.5rem",
                                letterSpacing: "1px",
                                textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                            }}
                        >
                            🧳 {selectedState} Tours
                        </h2>
                        <Row>
                            {toursByState.length > 0 ? (
                                toursByState.map((val) => (
                                    <Col key={val.id} xl={3} md={3} sm={6} xs={6} className="mb-4">
                                        <PopularCard val={val} />
                                    </Col>
                                ))
                            ) : (
                                <p className="text-muted">No tours available for {selectedState}.</p>
                            )}
                        </Row>

                        <div className="text-center mt-3">
                            <button
                                className="btn btn-outline-primary rounded-pill px-4"
                                onClick={() => window.location.href = `/state/${selectedState}`}
                            >
                                See More →
                            </button>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    )
}

export default ExplorebyState
